import {
    UpsellCardBaseProps,
    UpsellCardSpotlightComponentProps,
    UpsellCardSpotlightProps,
    UpsellCardSpotlightTheme,
} from '../models/upsell-card-props';
import { UpsellCardSpotlightDark } from './spotlight-themes/dark/UpsellCardSpotlightDark';
import { UpsellCardSpotlightLavender } from './spotlight-themes/lavender/UpsellCardSpotlightLavender';
import { UpsellCardSpotlightLime } from './spotlight-themes/lime/UpsellCardSpotlightLime';
import { UpsellCardSpotlightMint } from './spotlight-themes/mint/UpsellCardSpotlightMint';

const SPOTLIGHT_COMPONENTS: Record<UpsellCardSpotlightTheme, React.FC<UpsellCardSpotlightComponentProps>> = {
    lime: UpsellCardSpotlightLime,
    dark: UpsellCardSpotlightDark,
    mint: UpsellCardSpotlightMint,
    lavender: UpsellCardSpotlightLavender,
};

export const UpsellCardSpotlight: React.FC<UpsellCardBaseProps & UpsellCardSpotlightProps> = ({
    variant,
    theme = 'lime',
    ...props
}) => {
    const Component = SPOTLIGHT_COMPONENTS[theme];

    return (
        <div className="hover-reveal-group ">
            <Component {...props} />
        </div>
    );
};
